import { navItems, siteInfo } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg flex items-center justify-center bg-accent-500 text-background-50">
                <i className="ri-plant-line text-lg" />
              </span>
              <strong className="font-heading text-xl text-background-50">{siteInfo.name}</strong>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              {siteInfo.slogan}。我们更新日常段子、表情包与围观冷知识，也认真拆解吃瓜时那些说不清的心理活动。
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-5 inline-flex items-center gap-2 text-sm text-secondary-300 hover:text-secondary-200 transition-colors"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#categories" className="hover:text-accent-300 transition-colors">内容导航</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {navItems.slice(0, 5).map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-background-200 hover:text-background-50 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#about" className="hover:text-accent-300 transition-colors">关于与帮助</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#about" className="text-background-200 hover:text-background-50 transition-colors">我们是谁</a>
              </li>
              <li>
                <a href="#faq" className="text-background-200 hover:text-background-50 transition-colors">常见问题</a>
              </li>
              <li>
                <a href="#guide" className="text-background-200 hover:text-background-50 transition-colors">理性围观指南</a>
              </li>
              <li>
                <a href="#subscribe" className="text-background-200 hover:text-background-50 transition-colors">订阅瓜田日报</a>
              </li>
              <li>
                <a href="#contact" className="text-background-200 hover:text-background-50 transition-colors">联系与投稿</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-300">
          <p>© {year} {siteInfo.name} · 理性吃瓜，快乐围观</p>
          <p>本站内容用于日常阅读与娱乐，配图均为原创插画风格演示素材。</p>
        </div>
      </div>
    </footer>
  );
}